import type { NextPage } from 'next'
import Link from 'next/link'
import AddIcon from '../../svgIcons/Add'

import {ProjectAssessmentList, ListItem, SummaryItem} from "@/modules/project/interface";
import Dayjs from "@/components/dayjs";

interface IProps {
  title: string
  moreLink?: string
  detailLink?: string
  items: SummaryItem[]
}

const Component: NextPage<IProps> = ({title, moreLink, detailLink, items}) => {
  return (
    <div className='w-full'>
      <div className='flex items-center justify-between'>
        <div>
          <h3 className='text-[30px] font-medium tracking-[-2px] text-gg-blue'>{title}</h3>
        </div>
        <div>
          <Link href={moreLink || '#'}>
            <a className='text-[16px] text-gg-blue font-light flex items-center'>
              더보기
              <AddIcon className='inline mx-2' />
            </a>
          </Link>
        </div>
      </div>
      <hr className='mt-4 border-0 border-t-2 border-black' />
      <div className='divide-y divide-[#DDDDDD] border-b border-b-[#DDDDDD]'>
        {items && items.map((item, index) => (
          <div className='flex items-center justify-between py-4' key={index}>
            <div>
              <Link href={`${detailLink}/${item.idx}`}>
                <a className='text-[16px] text-[#666666] font-light'>{item.name}</a>
              </Link>
            </div>
            <div>
              <span className='text-[16px] text-[#666666] font-light'>
                <Dayjs format="date">{item.date}</Dayjs>
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Component
